import { Navigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";

/**
 * /lr-direct/* route entry.
 *
 * v3 model: browsing LR Direct is free for all authenticated users.
 * Privacy of private-network loads is enforced server-side via RLS on
 * direct_loads (private_only loads are only visible to invited providers,
 * shippers who own them, and admins). The paid gate lives at the BID action,
 * not the route boundary — see BidActionGate.
 */
export function LRDirectRouteGuard({ children }: { children: React.ReactNode }) {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="min-h-[40vh] flex items-center justify-center">
        <div className="text-sm text-muted-foreground">Loading…</div>
      </div>
    );
  }

  if (!user) return <Navigate to="/auth" replace />;

  return <>{children}</>;
}
